export enum InterventionsListColumns {
  NAME = 'Name',
  DESCRIPTION = 'Description',
  ACTIONS = 'Actions',
}
